import styled from 'styled-components';

const ErrorStyles = styled.div`
    margin: 50vh 10px 0;
    color: red;
    font-size: 20px;
    text-align: center;

    .error-message {
        font-weight: 700;
    }
`;

export default ErrorStyles;